import get from 'lodash/get';
import createPaginatableResource from '~/utils/createPaginatableResource';

export const { state, mutations, actions } = createPaginatableResource('reservations', ({ rootState }) => ({
  languageId: get(rootState, 'language.id'),
  type: 'active',
  limit: 3,
  offset: 0,
}));
